import { useState, useRef, useEffect, useMemo } from 'react';

// Comprehensive list of IANA timezone identifiers grouped by region
const TIMEZONE_DATA = [
  // Europe
  {
    value: 'Europe/London',
    label: 'London',
    region: 'Europe',
    offset: 'GMT/BST',
  },
  {
    value: 'Europe/Dublin',
    label: 'Dublin',
    region: 'Europe',
    offset: 'GMT/IST',
  },
  {
    value: 'Europe/Lisbon',
    label: 'Lisbon',
    region: 'Europe',
    offset: 'WET/WEST',
  },
  {
    value: 'Europe/Paris',
    label: 'Paris',
    region: 'Europe',
    offset: 'CET/CEST',
  },
  {
    value: 'Europe/Berlin',
    label: 'Berlin',
    region: 'Europe',
    offset: 'CET/CEST',
  },
  { value: 'Europe/Rome', label: 'Rome', region: 'Europe', offset: 'CET/CEST' },
  {
    value: 'Europe/Madrid',
    label: 'Madrid',
    region: 'Europe',
    offset: 'CET/CEST',
  },
  {
    value: 'Europe/Amsterdam',
    label: 'Amsterdam',
    region: 'Europe',
    offset: 'CET/CEST',
  },
  {
    value: 'Europe/Brussels',
    label: 'Brussels',
    region: 'Europe',
    offset: 'CET/CEST',
  },
  {
    value: 'Europe/Vienna',
    label: 'Vienna',
    region: 'Europe',
    offset: 'CET/CEST',
  },
  {
    value: 'Europe/Stockholm',
    label: 'Stockholm',
    region: 'Europe',
    offset: 'CET/CEST',
  },
  { value: 'Europe/Oslo', label: 'Oslo', region: 'Europe', offset: 'CET/CEST' },
  {
    value: 'Europe/Copenhagen',
    label: 'Copenhagen',
    region: 'Europe',
    offset: 'CET/CEST',
  },
  {
    value: 'Europe/Helsinki',
    label: 'Helsinki',
    region: 'Europe',
    offset: 'EET/EEST',
  },
  {
    value: 'Europe/Warsaw',
    label: 'Warsaw',
    region: 'Europe',
    offset: 'CET/CEST',
  },
  {
    value: 'Europe/Prague',
    label: 'Prague',
    region: 'Europe',
    offset: 'CET/CEST',
  },
  {
    value: 'Europe/Budapest',
    label: 'Budapest',
    region: 'Europe',
    offset: 'CET/CEST',
  },
  {
    value: 'Europe/Athens',
    label: 'Athens',
    region: 'Europe',
    offset: 'EET/EEST',
  },
  {
    value: 'Europe/Zurich',
    label: 'Zurich',
    region: 'Europe',
    offset: 'CET/CEST',
  },
  { value: 'Europe/Moscow', label: 'Moscow', region: 'Europe', offset: 'MSK' },
  {
    value: 'Europe/Istanbul',
    label: 'Istanbul',
    region: 'Europe',
    offset: 'TRT',
  },
  // Americas
  {
    value: 'America/New_York',
    label: 'New York',
    region: 'Americas',
    offset: 'EST/EDT',
  },
  {
    value: 'America/Toronto',
    label: 'Toronto',
    region: 'Americas',
    offset: 'EST/EDT',
  },
  {
    value: 'America/Chicago',
    label: 'Chicago',
    region: 'Americas',
    offset: 'CST/CDT',
  },
  {
    value: 'America/Denver',
    label: 'Denver',
    region: 'Americas',
    offset: 'MST/MDT',
  },
  {
    value: 'America/Phoenix',
    label: 'Phoenix',
    region: 'Americas',
    offset: 'MST',
  },
  {
    value: 'America/Los_Angeles',
    label: 'Los Angeles',
    region: 'Americas',
    offset: 'PST/PDT',
  },
  {
    value: 'America/Vancouver',
    label: 'Vancouver',
    region: 'Americas',
    offset: 'PST/PDT',
  },
  {
    value: 'America/Anchorage',
    label: 'Anchorage',
    region: 'Americas',
    offset: 'AKST/AKDT',
  },
  {
    value: 'Pacific/Honolulu',
    label: 'Honolulu',
    region: 'Americas',
    offset: 'HST',
  },
  {
    value: 'America/Mexico_City',
    label: 'Mexico City',
    region: 'Americas',
    offset: 'CST',
  },
  {
    value: 'America/Bogota',
    label: 'Bogota',
    region: 'Americas',
    offset: 'COT',
  },
  { value: 'America/Lima', label: 'Lima', region: 'Americas', offset: 'PET' },
  {
    value: 'America/Santiago',
    label: 'Santiago',
    region: 'Americas',
    offset: 'CLT/CLST',
  },
  {
    value: 'America/Sao_Paulo',
    label: 'Sao Paulo',
    region: 'Americas',
    offset: 'BRT',
  },
  {
    value: 'America/Buenos_Aires',
    label: 'Buenos Aires',
    region: 'Americas',
    offset: 'ART',
  },
  // Asia
  { value: 'Asia/Dubai', label: 'Dubai', region: 'Asia', offset: 'GST' },
  { value: 'Asia/Mumbai', label: 'Mumbai', region: 'Asia', offset: 'IST' },
  { value: 'Asia/Kolkata', label: 'Kolkata', region: 'Asia', offset: 'IST' },
  { value: 'Asia/Bangkok', label: 'Bangkok', region: 'Asia', offset: 'ICT' },
  { value: 'Asia/Jakarta', label: 'Jakarta', region: 'Asia', offset: 'WIB' },
  {
    value: 'Asia/Singapore',
    label: 'Singapore',
    region: 'Asia',
    offset: 'SGT',
  },
  {
    value: 'Asia/Hong_Kong',
    label: 'Hong Kong',
    region: 'Asia',
    offset: 'HKT',
  },
  { value: 'Asia/Shanghai', label: 'Shanghai', region: 'Asia', offset: 'CST' },
  { value: 'Asia/Taipei', label: 'Taipei', region: 'Asia', offset: 'CST' },
  { value: 'Asia/Tokyo', label: 'Tokyo', region: 'Asia', offset: 'JST' },
  { value: 'Asia/Seoul', label: 'Seoul', region: 'Asia', offset: 'KST' },
  { value: 'Asia/Manila', label: 'Manila', region: 'Asia', offset: 'PHT' },
  // Oceania
  {
    value: 'Australia/Perth',
    label: 'Perth',
    region: 'Oceania',
    offset: 'AWST',
  },
  {
    value: 'Australia/Adelaide',
    label: 'Adelaide',
    region: 'Oceania',
    offset: 'ACST/ACDT',
  },
  {
    value: 'Australia/Sydney',
    label: 'Sydney',
    region: 'Oceania',
    offset: 'AEST/AEDT',
  },
  {
    value: 'Australia/Melbourne',
    label: 'Melbourne',
    region: 'Oceania',
    offset: 'AEST/AEDT',
  },
  {
    value: 'Australia/Brisbane',
    label: 'Brisbane',
    region: 'Oceania',
    offset: 'AEST',
  },
  {
    value: 'Pacific/Auckland',
    label: 'Auckland',
    region: 'Oceania',
    offset: 'NZST/NZDT',
  },
  // Africa
  { value: 'Africa/Cairo', label: 'Cairo', region: 'Africa', offset: 'EET' },
  { value: 'Africa/Lagos', label: 'Lagos', region: 'Africa', offset: 'WAT' },
  {
    value: 'Africa/Johannesburg',
    label: 'Johannesburg',
    region: 'Africa',
    offset: 'SAST',
  },
  {
    value: 'Africa/Nairobi',
    label: 'Nairobi',
    region: 'Africa',
    offset: 'EAT',
  },
  // Other
  { value: 'UTC', label: 'UTC', region: 'Other', offset: 'UTC' },
];

interface TimezoneSelectorProps {
  value: string;
  onChange: (timezone: string) => void;
  disabled?: boolean;
  isLoading?: boolean;
}

/**
 * Get current UTC offset for a timezone (e.g., "+01:00" or "-05:00")
 */
function getTimezoneOffset(timezone: string): string {
  try {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timezone,
      timeZoneName: 'shortOffset',
    });
    const parts = formatter.formatToParts(now);
    const offsetPart = parts.find((part) => part.type === 'timeZoneName');
    return offsetPart?.value || '';
  } catch {
    return '';
  }
}

export function TimezoneSelector({
  value,
  onChange,
  disabled = false,
  isLoading = false,
}: TimezoneSelectorProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [highlightedIndex, setHighlightedIndex] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const listRef = useRef<HTMLUListElement>(null);

  // Get the selected timezone data
  const selectedTimezone = useMemo(() => {
    return (
      TIMEZONE_DATA.find((tz) => tz.value === value) || {
        value,
        label: value.split('/').pop()?.replace(/_/g, ' ') || value,
        region: 'Other',
        offset: '',
      }
    );
  }, [value]);

  // Filter timezones based on search query
  const filteredTimezones = useMemo(() => {
    if (!searchQuery.trim()) {
      return TIMEZONE_DATA;
    }

    const query = searchQuery.toLowerCase();
    return TIMEZONE_DATA.filter(
      (tz) =>
        tz.label.toLowerCase().includes(query) ||
        tz.value.toLowerCase().includes(query) ||
        tz.region.toLowerCase().includes(query) ||
        tz.offset.toLowerCase().includes(query)
    );
  }, [searchQuery]);

  // Group filtered timezones by region
  const groupedTimezones = useMemo(() => {
    const groups: Record<string, typeof TIMEZONE_DATA> = {};
    filteredTimezones.forEach((tz) => {
      if (!groups[tz.region]) {
        groups[tz.region] = [];
      }
      groups[tz.region].push(tz);
    });
    return groups;
  }, [filteredTimezones]);

  // Flatten for keyboard navigation
  const flatList = useMemo(() => {
    return filteredTimezones;
  }, [filteredTimezones]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
        setSearchQuery('');
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Focus input when dropdown opens
  useEffect(() => {
    if (isOpen && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isOpen]);

  // Scroll highlighted item into view
  useEffect(() => {
    if (isOpen && listRef.current && flatList.length > 0) {
      const highlightedEl = listRef.current.querySelector(
        `[data-index="${highlightedIndex}"]`
      );
      if (highlightedEl) {
        highlightedEl.scrollIntoView({ block: 'nearest' });
      }
    }
  }, [highlightedIndex, isOpen, flatList.length]);

  // Reset highlighted index when search changes
  useEffect(() => {
    setHighlightedIndex(0);
  }, [searchQuery]);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (!isOpen) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') {
        e.preventDefault();
        setIsOpen(true);
      }
      return;
    }

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        setHighlightedIndex((prev) =>
          prev < flatList.length - 1 ? prev + 1 : prev
        );
        break;
      case 'ArrowUp':
        e.preventDefault();
        setHighlightedIndex((prev) => (prev > 0 ? prev - 1 : prev));
        break;
      case 'Enter':
        e.preventDefault();
        if (flatList[highlightedIndex]) {
          onChange(flatList[highlightedIndex].value);
          setIsOpen(false);
          setSearchQuery('');
        }
        break;
      case 'Escape':
        e.preventDefault();
        setIsOpen(false);
        setSearchQuery('');
        break;
    }
  };

  const handleSelect = (timezone: string) => {
    onChange(timezone);
    setIsOpen(false);
    setSearchQuery('');
  };

  const currentOffset = getTimezoneOffset(value);

  return (
    <div ref={containerRef} className="relative">
      {/* Selected value button */}
      <button
        type="button"
        onClick={() => !disabled && setIsOpen(!isOpen)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        className="w-full px-4 py-3 rounded-lg border border-dark-200 focus:border-primary focus:ring-2 focus:ring-primary-100 outline-none transition-colors disabled:opacity-50 disabled:bg-dark-50 bg-white text-left flex items-center justify-between min-h-[44px] touch-manipulation"
        aria-haspopup="listbox"
        aria-expanded={isOpen}
      >
        <span className="flex items-center gap-2 truncate">
          <span className="text-dark">{selectedTimezone.label}</span>
          {currentOffset && (
            <span className="text-dark-400 text-sm">({currentOffset})</span>
          )}
        </span>
        <span className="flex items-center">
          {isLoading ? (
            <svg
              className="animate-spin h-5 w-5 text-dark-400"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              />
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
              />
            </svg>
          ) : (
            <svg
              className={`h-5 w-5 text-dark-400 transition-transform ${isOpen ? 'rotate-180' : ''}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M19 9l-7 7-7-7"
              />
            </svg>
          )}
        </span>
      </button>

      {/* Dropdown */}
      {isOpen && (
        <div className="absolute z-50 mt-1 w-full bg-white rounded-lg border border-dark-200 shadow-lg max-h-80 overflow-hidden">
          {/* Search input */}
          <div className="p-2 border-b border-dark-100">
            <div className="relative">
              <svg
                className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-dark-400"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
              <input
                ref={inputRef}
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Search cities..."
                className="w-full pl-9 pr-4 py-2 rounded-md border border-dark-200 focus:border-primary focus:ring-2 focus:ring-primary-100 outline-none text-sm"
              />
            </div>
          </div>

          {/* Options list */}
          <ul
            ref={listRef}
            className="overflow-y-auto max-h-60"
            role="listbox"
            aria-label="Timezones"
          >
            {flatList.length === 0 ? (
              <li className="px-4 py-3 text-dark-400 text-sm text-center">
                No timezones found
              </li>
            ) : (
              Object.entries(groupedTimezones).map(([region, timezones]) => (
                <li key={region}>
                  <div className="px-4 py-1.5 text-xs font-semibold text-dark-500 bg-dark-50 uppercase tracking-wide sticky top-0">
                    {region}
                  </div>
                  <ul>
                    {timezones.map((tz) => {
                      const index = flatList.findIndex(
                        (t) => t.value === tz.value
                      );
                      const isHighlighted = index === highlightedIndex;
                      const isSelected = tz.value === value;
                      const offset = getTimezoneOffset(tz.value);

                      return (
                        <li
                          key={tz.value}
                          data-index={index}
                          role="option"
                          aria-selected={isSelected}
                          onClick={() => handleSelect(tz.value)}
                          className={`px-4 py-2.5 cursor-pointer flex items-center justify-between min-h-[44px] touch-manipulation ${
                            isHighlighted
                              ? 'bg-primary-50'
                              : isSelected
                                ? 'bg-dark-50'
                                : 'hover:bg-dark-50'
                          }`}
                        >
                          <span className="flex items-center gap-2">
                            <span
                              className={`${isSelected ? 'font-medium text-primary' : 'text-dark'}`}
                            >
                              {tz.label}
                            </span>
                          </span>
                          <span className="text-dark-400 text-sm">
                            {offset}
                          </span>
                        </li>
                      );
                    })}
                  </ul>
                </li>
              ))
            )}
          </ul>
        </div>
      )}
    </div>
  );
}
